import { atom } from 'recoil';
import { Role } from './RolesState';

export interface User {
  id?: number;
  avatarUrl?: any;
  profileColor?: any;
  firstName?: string;
  emailId: string;
  phoneNo?: string;
  username?: string;
  roles?: Role[];
  scopeLevel?: string;
  stateIds?: string[];
  districtIds?: string[];
  blockIds?: string[];
  facilityIds?: string[];
  // Present on the logged-in user's own auth object (states/AuthState.ts),
  // not on other users' records.
  authToken?: string;
  token?: any;
  // false while the user is still on the default password emailed at
  // onboarding (login response); see helpers/passwordPolicy.ts.
  passwordUpdated?: boolean;
}

export const usersForCurrentRoleState = atom<User[]>({
  key: 'usersForCurrentRole',
  default: [],
});

export const usersState = atom<User[]>({
  key: 'users',
  default: [],
});

// Current user
export const currentUserState = atom({
  key: 'currentUser',
  default: {} as User,
});
